import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Button } from '../components/ui/button';

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#0a0a0c]">
      <Navbar />
      <div className="max-w-lg mx-auto px-5 pt-16 pb-24 text-center">
        <div className="bg-[#101014] border border-[#1e1e26] rounded-3xl p-10">
          <div className="w-14 h-14 rounded-full bg-[#1a1a20] border border-[#26262e] flex items-center justify-center mx-auto mb-5">
            <XCircle className="w-7 h-7 text-[#c9c6bf]" />
          </div>
          <h1 className="serif text-3xl text-white mb-2">Checkout cancelled</h1>
          <p className="text-[#a8a49b]">No worries — nothing was charged. Pick up where you left off whenever you’re ready.</p>
          <div className="flex flex-col sm:flex-row gap-2 justify-center mt-6">
            <Link to="/pricing"><Button className="bg-[#ea9a6f] hover:bg-[#e0895a] text-[#0a0a0c] rounded-full h-11 px-6">Back to pricing</Button></Link>
            <Link to="/app"><Button variant="outline" className="border-[#2a2a30] bg-transparent text-white hover:bg-[#14141a] rounded-full h-11 px-6">Keep exploring</Button></Link>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
